import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMNS,
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE_BY_DENSITY,
  CARDS_GRID_ROW_SPACING,
} from '@app/components/base/content-structure/cards-grid-config';
import { useIsActiveStationVideo } from '@app/core/stations/hooks/useIsActiveStationVideo';
import { Box, Skeleton } from '@mui/material';
import {
  FRAGMENT_LIST_CONTAINER_SX,
  FRAGMENTS_GRID_SKELETON_CARD_COUNT,
  FRAGMENTS_LIST_SKELETON_CARD_COUNT,
} from '../../fragment-card/constants';
import { useFragmentGridContext } from '../FragmentGridContext';
import { AudioFragmentCardSkeleton } from './AudioFragmentCardSkeleton';
import { FragmentCardListSkeleton } from './FragmentCardListSkeleton';
import { VideoFragmentCardSkeleton } from './VideoFragmentCardSkeleton';

/**
 * Skeleton shown during initial load. List view: single column; grid view: grid by viewMode.
 */
export function FragmentsGridSkeleton() {
  const isVideo = useIsActiveStationVideo();
  const { viewMode } = useFragmentGridContext();

  return (
    <Box>
      <Box sx={{ mb: 1 }}>
        <Skeleton width="200px" height={24} />
      </Box>
      {viewMode === 'list' ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: CARDS_GRID_ROW_SPACING,
            ...FRAGMENT_LIST_CONTAINER_SX,
          }}
        >
          {Array.from({
            length: FRAGMENTS_LIST_SKELETON_CARD_COUNT,
          }).map((_, i) => (
            <FragmentCardListSkeleton key={i} />
          ))}
        </Box>
      ) : (
        <CardsGrid
          columns={CARDS_GRID_DENSE_COLUMNS}
          columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}
        >
          {Array.from({ length: FRAGMENTS_GRID_SKELETON_CARD_COUNT }).map((_, i) => (
            <CardsGridItem size={CARDS_GRID_ITEM_SIZE_BY_DENSITY[viewMode]} key={i}>
              {isVideo ? <VideoFragmentCardSkeleton /> : <AudioFragmentCardSkeleton />}
            </CardsGridItem>
          ))}
        </CardsGrid>
      )}
    </Box>
  );
}
